import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function staticFilterReducerFactory(rootProp, initialState) {
    return function staticFilterReducer(state = initialState, action) {
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${GenericActions.VALUE_ADDED}`:
                return state.setIn([action.stateProp, "value"], action.payload);
            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return initialState;
            default:
                return state;
        }
    };
}
